import { render, staticRenderFns } from "./car-archive-details.vue?vue&type=template&id=509d61cd&scoped=true&"
import script from "./car-archive-details.vue?vue&type=script&lang=js&"
export * from "./car-archive-details.vue?vue&type=script&lang=js&"
import style0 from "./car-archive-details.vue?vue&type=style&index=0&id=509d61cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509d61cd",
  null
  
)

export default component.exports